/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import Image, { ImageProps } from './Image';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-image': Partial<HTMLElement> & ImageProps & Partial<{ ref: any }>;
    }
  }
}

export function defineSolidImage(): void {
  customElement(
    'tc-image',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      src: '',
      className: 'thumbnail micro',
      errImg: '',
      onClick: undefined,
    },
    Image
  );
}
